<template>
  <div>
    <h3>Social Learning</h3>
    <Summary :isLoadingSummary="isLoadingSummary" :summaryData="summaryData" />
    <CardGrid
      :isLoading="isLoadingTNA"
      :items="socialLearningData"
      :selectedItems="selectedItems"
      :isCanSelect="true"
      :forceSelect="false"
      :type="'social'"
      :activeTab="activeTab"
      :isLoadingTNA="isLoadingTNA"
      @open-detail="handleOpenModalDetail"
      @select-change="$emit('select-change', ...arguments)"
    />
    <!-- <DetailTNA
      :isLoadingModal="isLoadingModal"
      :showDetailModal="showDetailModal"
      :selectedTNA="dataModal"
      @close="() => $emit('close-detail')"
    /> -->
    <DetailTNASocial
      :isLoadingModal="isLoadingModal"
      :showDetailModal="showDetailModal"
      :selectedTNA="dataModal"
      @close="() => $emit('close-detail')"
    />
  </div>
</template>

<script>
import DetailTNA from "../modal/DetailTNA.vue";
import DetailTNASocial from "../modal/DetailTNASocial.vue";
import CardGrid from "./card-grid.vue";
import Summary from "./summary.vue";

export default {
  name: "Social",
  emits: ["close-detail", "select-change"],
  components: { Summary, CardGrid, DetailTNA, DetailTNASocial },

  props: {
    isLoadingSummary: Boolean,
    isLoadingTNA: Boolean,
    isLoadingModal: Boolean,
    summaryData: Object,
    socialLearningData: Array,
    handleOpenModalDetail: Function,
    showDetailModal: Boolean,
    dataModal: Object,
    activeTab: String,
    selectedItems: Array,
  },
};
</script>
